<app-header [showAvatar]="false" title="{{headerTitle}}" [useTabs]="false">
  <div id="top-actions">
    <reb-ngx-mat-button size="small" (click)="showDialogNewNotifications()">CREATE NOTIFICATION</reb-ngx-mat-button>
  </div>
</app-header>
<div class="body">
  <div class="body-container">
    <div class="page-main">
      <div class="page-container">
        <div class="page-section">
          <div class="page-section-head">
            <div class="form-wrapper">
              <div class="form-content">
                <div class="form-section form-currencies-list">
                  <div class="form-section-side">
                    <div *ngIf="notificationSectionKeyName === _notificationSectionValues.onBoardingEmails" class="form-section-inner">
                      <h1 class="label-title">Subscription Statuses</h1>
                      <p class="label-subtitle">From onboarding to churn, keep your subscribers informed about changes made to their subscription status.</p>
                    </div>
                    <div *ngIf="notificationSectionKeyName === _notificationSectionValues.subscriptionChanges" class="form-section-inner">
                      <h1 class="label-title">Subscription Updates</h1>
                      <p class="label-subtitle">Notify your customers when changes are made to their subscriptions.</p>
                    </div>
                    <div *ngIf="notificationSectionKeyName === _notificationSectionValues.subscriptionRenewalReminders" class="form-section-inner">
                      <h1 class="label-title">Subscription Reminders</h1>
                      <p class="label-subtitle">Remind your customers that their subscription is about to renew.</p>
                    </div>
                    <div *ngIf="notificationSectionKeyName === _notificationSectionValues.subscriptionActivation" class="form-section-inner">
                      <h1 class="label-title">Subscription Activation</h1>
                      <p class="label-subtitle">Email customers who move to an Active subscription. Tell them how much they'll be charged going forward, and more.</p>
                    </div>
                    <div *ngIf="notificationSectionKeyName === _notificationSectionValues.paymentsAndCredits" class="form-section-inner">
                      <h1 class="label-title">Payments and Credits</h1>
                      <p class="label-subtitle">Email customers about payments, charges, credits, and follow up with payment reminders.</p>
                    </div>
                    <div *ngIf="notificationSectionKeyName === _notificationSectionValues.invoiceReceipt" class="form-section-inner">
                      <h1 class="label-title">Invoice Receipt</h1>
                      <p class="label-subtitle">Notify customers every time an invoice is generated.</p>
                    </div>
                    <div *ngIf="notificationSectionKeyName === _notificationSectionValues.paymentCollect" class="form-section-inner">
                      <h1 class="label-title">Payment Collect</h1>
                      <p class="label-subtitle">Notify your customers when a payments are collected successful.</p>
                    </div>
                    <div *ngIf="notificationSectionKeyName === _notificationSectionValues.dunningForOnlinePayments" class="form-section-inner">
                      <h1 class="label-title">Dunning for Online Payments</h1>
                      <p class="label-subtitle">Notify customers about payment failures and payment collection retries for recurring and one-time invoices.</p>
                    </div>
                    <div *ngIf="notificationSectionKeyName === _notificationSectionValues.customerOnBoardingEmails" class="form-section-inner">
                      <h1 class="label-title">Onboarding Emails</h1>
                      <p class="label-subtitle">Send welcome emails to new customers. Tell them of the benefits, the features, and the nothing-like-its you provide.</p>
                    </div>
                    <div *ngIf="notificationSectionKeyName === _notificationSectionValues.customerPaymentMethods" class="form-section-inner">
                      <h1 class="label-title">Payment Methods</h1>
                      <p class="label-subtitle">Notify your customers when payment methods are created, are about to expire, have expired, or are invalid.</p>
                    </div>
                    <div *ngIf="notificationSectionKeyName === _notificationSectionValues.automaticProcess" class="form-section-inner">
                      <h1 class="label-title">Runtime Tasks</h1>
                      <p class="label-subtitle">Set notifications for the runtime tasks running without human intervention.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="page-section-body section-notification-events">
            <div class="form-wrapper">
              <div class="form-content">
                <div class="form-section">
                  <div class="form-section-container padding nopadding">

                    <section *ngIf="isNotificationsByKeyNameReady && collectionOfNotifications.length === 0" class="message">
                      <div class="message-wrapper">
                        <div class="message-inner nodata">
                          <div class="message-body">
                            <h1 class="message-title">There are no notifications</h1>
                          </div>
                        </div>
                      </div>
                    </section>

<!--
                    <div  class="form-section-body">
                      <mat-card class="custom-mat-card card-form-wrapper size size1of1">
                        <div class="card-section padding nopadding">
                          <mat-list class="custom-mat-list list-grid-std list-notification-events">
                            <mat-list-item class="custom-mat-list-item grid-row">
                              <div class="cell-wrapper">...</div>
                            </mat-list-item>
                          </mat-list>
                        </div>
                      </mat-card>
                    </div>
-->

                    <div *ngFor="let notification of collectionOfNotifications" class="form-section-body">
                      <div class="form-block">
                        <div class="block-head">
                          <div class="form-panel">
                            <h1 class="typo subheading-1 fw300 italic semi-condensed">When <span class="typo subheading-1 fw400 semi-condensed italic">{{notification.systemEvent.displayName}}</span></h1>
                          </div>
                        </div>
                        <mat-card class="custom-mat-card card-form-wrapper size size1of1">
                          <mat-card-content class="card-content">
                            <div class="card-section padding nopadding">
                              <mat-list class="custom-mat-list list-grid-std list-notifications-channels">
                                <mat-list-item *ngFor="let channel of notification.companyNotificationChannels"  class="custom-mat-list-item grid-row">
                                  <div class="cell-wrapper">
                                    <div class="cell">
                                      <p class="typo body-1 fw300">
                                        <span *ngIf="channel.keyName === 'companyNotificationInbox'">
                                          <span class="label-conditional-notify">
                                            <span class="typo subheading-1 fw400">Push: </span>
                                              A push notification will be added to internal notification bell
                                          </span>
                                        </span>
                                        <span *ngIf="channel.keyName === 'merchantEmail' || channel.keyName === 'merchantSmtp' || channel.keyName === 'customerGoogle' || channel.keyName === 'customerSmtp'">
                                          <span class="typo subheading-1 fw400">Email: </span>
                                          <span class="label-conditional-notify">An email notification will be delivered from 
                                            <span class="typo subheading-1 fw400">{{ channel.displayName }}</span>
                                            <span class="label-conditional-notify"> via </span>
                                            <span class="typo subheading-1 fw400">{{ channel.companyIntegration.displayName }}</span>
                                          </span>
                                        </span>
                                        <!-- <span class="label-conditional-notify">Notify</span>
                                        <span *ngIf="channel.keyName === 'companyNotificationInbox'" class="typo subheading-1 italic fw400">< Company Inbox ></span>
                                        <span *ngIf="channel.keyName === 'merchantEmail' || channel.keyName === 'merchantSmtp'" class="typo subheading-1 italic fw400">< Company Email ></span>
                                        <span *ngIf="channel.keyName === 'customerGoogle' || channel.keyName === 'customerSmtp'" class="typo subheading-1 italic fw400">< Customer ></span>
                                        <span class="label-conditional-notify">using</span>
                                        <span class="typo subheading-1 italic fw400">< {{channel.displayName}} ></span> -->
                                      </p>
                                    </div>
                                    <div class="cell col-status">
                                      <div class="cell-inner">
                                        <mat-slide-toggle [checked]="channel.status === _companyNotificationChannelStatus.active" (change)="updateNotificationChannelStatus(notification.id, channel.id, channel.status)" class="custom-mat-slide-toggle align asidePos" color="primary"></mat-slide-toggle>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="cell-wrapper col-actions">
                                    <button mat-icon-button [matMenuTriggerFor]="gridActions" class="custom-mat-icon-button button-actions">
                                      <mat-icon svgIcon="ico-actions" class="custom-mat-icon ico-size ico-xs"></mat-icon>
                                    </button>
                                    <mat-menu #gridActions="matMenu" [overlapTrigger]="false" class="custom-mat-menu-panel">
                                      <a  *ngIf="channel.keyName !== 'companyNotificationInbox'" mat-menu-item class="custom-mat-menu-item" (click)="sendTest(notification.id, channel.id, channel.status)">
                                        <mat-icon svgIcon="ico-email" class="custom-mat-icon ico-size ico-1xs"></mat-icon>Send Test
                                      </a>
                                      <a mat-menu-item class="custom-mat-menu-item" (click)="showDialogNewNotifications({notification, channel})">
                                        <mat-icon svgIcon="ico-preview" class="custom-mat-icon ico-size ico-1xs"></mat-icon>Change Sender
                                      </a>
                                      <a mat-menu-item class="custom-mat-menu-item item-disabled">
                                        <mat-icon svgIcon="ico-preview" class="custom-mat-icon ico-size ico-1xs"></mat-icon>Preview
                                      </a>
                                      <a mat-menu-item (click)="redirectTo(channel.keyName, channel.companyNotificationTemplate.id)" routerLinkActive="router-link-active"  class="custom-mat-menu-item">
                                        <mat-icon svgIcon="ico-edit" class="custom-mat-icon ico-size ico-1xs"></mat-icon>Edit
                                      </a>
                                      <a mat-menu-item (click)="showDialogConfirmationForDeleteChannelNotification(notification.id, channel)" routerLinkActive="router-link-active"  class="custom-mat-menu-item item-danger">
                                        <mat-icon svgIcon="ico-delete" class="custom-mat-icon ico-size ico-1xs"></mat-icon>Delete
                                      </a>
                                    </mat-menu>
                                  </div>
                                </mat-list-item>
                              </mat-list>
                            </div>
                          </mat-card-content>
                        </mat-card>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- skeleton
          <div *ngIf="!isNotificationsByKeyNameReady" class="page-section">
            <div class="page-section-head">
              <h1 lass="typo subheading-1 fw400 semi-condensed label-title" matline><skeleton-loader
                [theme]="{'width': '250px'}"></skeleton-loader>
              </h1>
            </div>
            <div class="page-section-body">
              <mat-card class="custom-mat-card card-form-wrapper size size1of1">
                <mat-card-content class="card-content">
                  <div class="card-section padding nopadding">
                    <mat-list class="custom-mat-list list-grid-std list-notification-events">
                      <mat-list-item class="custom-mat-list-item grid-row">
                        <div class="cell col-filter-name">
                          <label class="label-primary"><skeleton-loader
                            [theme]="{'width': '150px'}"></skeleton-loader>
                          </label>
                        </div>
                        <div class="cell col-channel" style="margin-left: 90px;">
                          <p matLine ><skeleton-loader
                            [theme]="{'width': '130px'}"></skeleton-loader></p>
                            <p matLine ><skeleton-loader
                              [theme]="{'width': '160px'}"></skeleton-loader></p>
                            </div>
                          </mat-list-item>
                        </mat-list>
                      </div>
                    </mat-card-content>
                  </mat-card>
                </div>
              </div>
            -->
      </div>
    </div>
  </div>
</div>
